import {Device, DeviceSize} from 'epic-fortnite-styles/constants';
import styled from 'styled-components';

const SubTitle = styled.h1`
  && {
    color: black;
    letter-spacing: 0.2em;
    font-size: 1.5em;
    margin: 0.8em 0 0.2em 0;
    @media screen and ${Device.laptopL} {
      font-size: 1.1em;
    }
    @media screen and ${Device.laptop} {
      font-size: 0.8em;
    }
    line-height: 1;
    font-style: italic;
  }
  .es_ES,
  .es_MX,
  .fr,
  .it {
    font-size: 6em;
    @media screen and (min-width: ${DeviceSize.tablet}) {
      font-size: 8em;
    }
    @media screen and (min-width: ${DeviceSize.laptop}) {
      font-size: 6em;
    }
    @media screen and (min-width: 1200px) {
      font-size: 8em;
    }
    @media screen and (min-width: 1600px) {
      font-size: 10em;
    }
  }
  .pt_BR {
    font-size: 3em;
    @media screen and (min-width: ${DeviceSize.tablet}) {
      font-size: 5em;
    }
    @media screen and (min-width: ${DeviceSize.laptop}) {
      font-size: 4em;
    }
    @media screen and (min-width: 1200px) {
      font-size: 6em;
    }
    @media screen and (min-width: 1600px) {
      font-size: 10em;
    }
  }
  .pl {
    font-size: 5em;
  }
  .ru {
    font-size: 5em;
  }
  .tr {
    font-size: 5em;
    @media screen and (min-width: ${DeviceSize.tablet}) {
      font-size: 6em;
    }
    @media screen and (min-width: ${DeviceSize.laptop}) {
      font-size: 4em;
    }
    @media screen and (min-width: 1200px) {
      font-size: 6em;
    }
    @media screen and (min-width: 1600px) {
      font-size: 10em;
    }
  }
  @media screen and ${Device.mobileL} {
    display: none;
  }
`;

export default SubTitle;
